import React from "react";
import Image from "../common/Image";

interface ImageContainerProps {
  imageUrl: string;
}

const ImageContainer: React.FC<ImageContainerProps> = ({ imageUrl }) => {
  return (
    <div>
      <Image src={imageUrl} alt="Program Image" />
    </div>
  );
};

export default ImageContainer;
